import React, { useState, useEffect } from 'react';
import { Alert, Form } from 'react-bootstrap';

import PasswordFormGroup from './PasswordFormGroup.jsx';

import ButtonLoaderComponent from '../widgets/ButtonLoaderComponent.jsx';
import { useStoreActions } from 'easy-peasy';
import { useToast } from '../../hooks/useToast.jsx';

const PassWordComponent = ({ setModalShow = null }) => {
    const {changePassword} = useStoreActions(actions => actions.auth);

    const [isSending, setIsSending] = useState(false);

    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [samePasswordsError, setSamePasswordsError] = useState(false);

    const [isNewPassValid, setIsNewPassValid] = useState(false);

    const toast = useToast();

    useEffect(() => {
        if (newPassword && newPassword == password) {
            setSamePasswordsError(true);
        } else if (!!samePasswordsError) {
            setSamePasswordsError(false);
        }
    }, [password, newPassword]);


    const myPassword =
        <Form.Group>
            <Form.Label>Mot de passe actuel</Form.Label>
            <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                type="password"
                placeholder="Mot de passe actuel"
            />
        </Form.Group>;

    const passWordGroup = <PasswordFormGroup 
        onValid={(validation, validPass) => {
            setIsNewPassValid(validation);
            setNewPassword(validPass)
        }}
    />;

    const onValidatePWD = () => {

        if (isNewPassValid && !samePasswordsError) {
            const data = new FormData();
            
            data.append('pwd', newPassword);
            data.append('lastPassword', password);
            
            setIsSending(true);
            changePassword(data)
                .then((res) => {
                    if (res) {
                        toast.open({ message: "Le mot de passe a bien été modifié", variant: "success" });
                        setIsSending(false);
                        setModalShow?.(false);
                    }
                })
                .finally(() => {
                    setIsSending(false);
                })

        }
    };

    return <>
        <Form noValidate className="mb-3">
            {myPassword}
            {passWordGroup}
        </Form>
        {samePasswordsError &&
            <Alert variant='danger'>
                Le nouveau mot de passe doit être différent de l'ancien.
            </Alert>}
        <ButtonLoaderComponent
            variant='success'
            disabled={password === "" || !isNewPassValid || samePasswordsError}
            isSending={isSending}
            msg='Changer le mot de passe'
            onClick={() => { onValidatePWD() }}
        />
    </>;
}

export default PassWordComponent;